import { createClient } from '@supabase/supabase-js'
import type { Database } from './database.types'
import { env } from './env'

// Cliente único do navegador. Usa a chave "publishable" (pública): toda a
// autorização acontece no banco, com RLS e funções RPC validadas.
export const supabase = createClient<Database>(env.supabaseUrl, env.supabasePublishableKey, {
  auth: {
    flowType: 'pkce',
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
